<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted() {
    this.$store.dispatch('getHostname')
  },
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  padding: 0px;
  margin: 0px;
  overflow: auto;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue